import React from 'react'

const NoneValue = () => <span>&ndash;</span>

export default NoneValue
